import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MessageSquare, ShieldCheck, FileText } from "lucide-react";
import Navbar from "../components/public/Navbar";
import Footer from "../components/public/Footer";
import { termsContent, company } from "../mock";

function Block({ icon: Icon, title, children }) {
  return (
    <div className="mb-10">
      <div className="flex items-center gap-3 mb-4">
        <div className="h-10 w-10 rounded-lg bg-gold/15 flex items-center justify-center">
          <Icon className="h-5 w-5 text-gold-dark" />
        </div>
        <h2 className="font-serif text-2xl font-bold text-navy">{title}</h2>
      </div>
      <div className="text-gray-600 leading-relaxed space-y-3">{children}</div>
    </div>
  );
}

export default function TermsPage() {
  useEffect(() => window.scrollTo(0, 0), []);
  const { sms, privacy, disclaimer } = termsContent;

  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <div className="bg-navy pt-36 pb-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-gold-light hover:text-gold text-sm mb-4">
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
          <h1 className="font-serif text-4xl font-bold text-white">
            Terms &amp; Conditions
          </h1>
          <p className="mt-3 text-gray-300">
            Please review our SMS terms, privacy policy and disclaimers.
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14">
        <Block icon={MessageSquare} title={sms.title}>
          {sms.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
          <p className="font-semibold text-navy">Opt-Out &amp; Support</p>
          <p>{sms.optOut}</p>
          <p className="font-semibold text-navy">Privacy &amp; Data Usage</p>
          <p>{sms.privacy}</p>
        </Block>

        <Block icon={ShieldCheck} title={privacy.title}>
          <p>{privacy.intro}</p>
          <p className="font-semibold text-navy">1. Information We Collect</p>
          <ul className="list-disc pl-5 space-y-1">
            {privacy.collect.map((c) => <li key={c}>{c}</li>)}
          </ul>
          <p className="font-semibold text-navy">2. How We Use Your Information</p>
          <ul className="list-disc pl-5 space-y-1">
            {privacy.use.map((c) => <li key={c}>{c}</li>)}
          </ul>
          <p className="font-semibold text-navy">3. Your Rights (North Carolina Residents)</p>
          <ul className="list-disc pl-5 space-y-1">
            {privacy.rights.map((c) => <li key={c}>{c}</li>)}
          </ul>
          <p>
            To exercise these rights, email us at{" "}
            <a className="text-gold-dark font-medium" href={`mailto:${company.supportEmail}`}>
              {company.supportEmail}
            </a>.
          </p>
        </Block>

        <Block icon={FileText} title="Disclaimer">
          <p>{disclaimer}</p>
          <p className="text-sm text-gray-500">
            This website contains educational information about general and credit
            matters. The information is not advice and should not be treated as
            such. You should consult your attorney or professional advisor for
            specific legal matters.
          </p>
        </Block>
      </div>
      <Footer />
    </div>
  );
}
